import SelectExtend from "./src";
import type { App } from "vue";

SelectExtend.install = function (Vue: App): void {
  console.info("SelectExtend----install----");
  Vue.component(SelectExtend.name, SelectExtend);
};

export default SelectExtend;
